export{isMobile}from"./isMobile.js";export{getInterrelatedPropertyURLs}from"./interrelated-property.js";
